@if (notepad()) {
  <div class="wrapper">
    <form [formGroup]="notepad().form">
      <div class="wrapper__floating-header" [@enterAnimation]>
        @if (showFloatingHeader$()) {
          <ng-container *ngTemplateOutlet="notepadHeader"></ng-container>
        }
      </div>

      <section id="notepad" class="empathy-notepad">
        <div class="empathy-notepad__content">
          <ng-container *ngTemplateOutlet="notepadHeader"></ng-container>

          <div class="empathy-notepad__content__box" cdkTrapFocus cdkDropList (cdkDropListDropped)="onReorder($event)">
            @for (question of getQuestions().controls; track question; let index = $index) {
              <div
                id="question-{{ question.get('questionId').value }}"
                class="empathy-notepad__content__container"
                cdkDrag
                [cdkDragDisabled]="readonly() || getQuestions().controls.length <= 1"
                [@cardAnimation]="index"
              >
                @if (!readonly() && getQuestions().controls.length > 1) {
                  <fa-icon
                    [icon]="faGripDotsVertical"
                    [title]="'Re-order ' + question.get('questionId').value"
                    class="empathy-notepad__content__container-drag"
                    cdkDragHandle
                  ></fa-icon>
                }
                <empathy-question-form
                  [question]="question"
                  [commentCount]="onCommentsCountById(question.get('questionId').value)"
                  [readonly]="readonly()"
                  [canComment]="canComment()"
                  (addComment)="onAddComment($event)"
                  (filterComments)="onFilterComments($event)"
                  (update)="onUpdateNotepadQuestions(index, $event)"
                  (delete)="onDeleteNotepadQuestion(index)"
                />
              </div>
            } @empty {
              <div class="empathy-notepad__content__empty">
                <p class="empty__warning fs__sm fw__600">Start by adding a question to the survey</p>
              </div>
            }
          </div>
        </div>
      </section>
    </form>
    <div class="comments">
      <empathy-notepad-side-tabs [selectedTab]="selectedTab$()" [showComments]="canComment()" (selectedIndexChange)="onTabChange($event)">
        <empathy-comments-list
          slot="comments"
          [comments]="notepadComments()"
          [allowFilterRemoval]="true"
          [readonly]="!canComment()"
          (selectHashtag)="onScrollToComment($event)"
          (computedHashtags)="onParseCommentsCount($event)"
          (addComment)="addComment.emit($event)"
          (updateComment)="updateComment.emit($event)"
          (postReply)="postReply.emit($event)"
        ></empathy-comments-list>

        <div class="preview" slot="preview">
          @if (!fullPreview$()) {
            <empathy-notepad-full-preview
              [notepad]="notepad()"
              [selectedActiveDevice]="previewDevice.Phone"
              (fullPreview)="fullPreview.emit()"
            ></empathy-notepad-full-preview>
          }
        </div>
      </empathy-notepad-side-tabs>
    </div>
  </div>
}

<ng-template #notepadHeader>
  <header #header id="notepad-header" class="empathy-notepad__content__header">
    <h1 class="empathy-notepad__content__header__title fs__lg fw__600">{{ notepad().research.title ?? 'Welcome to the Notepad Editor' }}</h1>
    @if (!readonly()) {
      <div class="empathy-notepad__content__header__actions">
        <button
          mat-stroked-button
          [color]="notepad().form.get('programmerNotes').value?.length > 0 ? 'alert' : undefined"
          class="empathy-notepad__content__header__actions__button"
          (click)="onOpenProgrammerNotes()"
        >
          <fa-icon [icon]="faLaptopBinary"></fa-icon>
          <span>{{ notepad().form.get('programmerNotes').value?.length > 0 ? 'Edit survey logic notes' : 'Add survey logic notes' }}</span>
        </button>

        <button mat-flat-button color="primary" cdkOverlayOrigin #addQuestionTrigger="cdkOverlayOrigin" (click)="onToggleAddQuestion(addQuestionTrigger)">
          <fa-icon [icon]="faDiagramCells"></fa-icon>
          <span>Add question</span>
        </button>
      </div>
    }
  </header>
</ng-template>

<ng-template
  cdkConnectedOverlay
  cdkConnectedOverlayPush="true"
  [cdkConnectedOverlayOrigin]="activeOverlayOrigin$()"
  [cdkConnectedOverlayOpen]="showAddQuestion$()"
  (overlayOutsideClick)="showAddQuestion$.set(false)"
  (detach)="showAddQuestion$.set(false)"
>
  <empathy-question-type-select (completed)="onAddQuestion($event)" />
</ng-template>
